<template>
  <div class="head">
    <van-row style="line-height: 50px">
      <van-col span="4" @click="goback">
        <van-icon name="arrow-left" class="head-icon" ></van-icon>
        <span class="Back">返回</span>
      </van-col>
      <van-col span="14" class="toptitle">{{ title }}</van-col>
      <van-col v-if="isShow"  @click="siginOut"  span="5" style="text-align: right"
        ><van-icon name="revoke"/> <span>退出</span></van-col
      >
    </van-row>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    isShow: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    goback() {
      this.$router.back();
    },
    async siginOut() {
      this.$toast.loading({
        duration: 0, // 持续时间，0表示持续展示不停止
        forbidClick: true, // 是否禁止背景点击
        message: "退出中...", // 提示消息
      });
      await this.$store
        .dispatch("LogOut")
        .then((res) => {
          this.$router.push({ path: "/login" });
          this.$toast.success("退出成功");
        })
        .catch(() => {
          this.loading = false;
          this.$toast.fail("退出失败");
        });
    },
  },
};
</script>

<style lang="less">
@bgc: #ffffff;
.head {
  height: 50px;
  background: @bgc;
  // margin: 0 5px;
  opacity: 1;
  z-index: 99;
  position: relative;
  .head-icon {
    position: absolute;
    top: 16px;
    left: 6px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .Back{
    position: absolute;
    top: -2px;
    font-size: 16px;
    left: 26px;
    cursor: pointer;
  }
  .toptitle{
    text-align: center;
     font-weight: bold; 
     font-size: 18px;
     letter-spacing: 1px;
}
}
</style>

